import DangerZone from './DangerZone';

export default DangerZone;
